import { render } from "./B2bFilterButtonDeliveryNotesEmit.vue?vue&type=template&id=7aff3197&scoped=true&lang=pug"
import script from "./B2bFilterButtonDeliveryNotesEmit.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonDeliveryNotesEmit.vue?vue&type=script&lang=js"

import "./B2bFilterButtonDeliveryNotesEmit.vue?vue&type=style&index=0&id=7aff3197&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aff3197"]])

export default __exports__